import { RouterMenu } from '@core/config/routing-menu';

export const MENU_ITEMS_LEFT = [
  {
    title: 'Menu.global_position',
    titleMobile: 'Menu.global_position',
    link: RouterMenu.GLOBAL_POSITION,
    classIcon: 'ico-home',
  },
  {
    title: 'Menu.accounts',
    titleMobile: 'Menu.accounts',
    link: RouterMenu.TRANSACTIONS,
    classIcon: 'ico-coins',
  },
  {
    title: 'Menu.deposits',
    titleMobile: 'Menu.deposits',
    link: RouterMenu.DEPOSIT,
    classIcon: 'ico-euro',
  },
  {
    title: 'Menu.requests',
    titleMobile: 'Menu.requests',
    link: RouterMenu.CASES,
    classIcon: 'ico-dialog',
  },
];
export const MENU_ITEMS_RIGTH = [
  {
    title: 'Menu.profile',
    titleMobile: 'Menu.profile',
    classIcon: 'ico-user',
    link: RouterMenu.PERSONAL_DATA,
  },
  {
    title: 'Menu.mailbox',
    titleMobile: 'Menu.mailbox',
    classIcon: 'ico-mail',
    link: RouterMenu.VIRTUAL_MAILBOX,
  },
  {
    title: 'Menu.documents',
    titleMobile: 'Menu.documents',
    classIcon: 'ico-files',
    link: RouterMenu.DOCUMENTATION,
  },
  {
    title: 'Menu.help',
    titleMobile: 'Menu.help',
    classIcon: 'ico-question',
    link: RouterMenu.HELP,
  },
];
